import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Legacy dashboard components (preserved inside the collapsible Master Card)
import Snapshot from '../components/Dashboard/Snapshot';
import TrackImpactMatrix from '../components/Dashboard/TrackImpactMatrix';
import SubmissionStats from '../components/Dashboard/SubmissionStats';
import Referrals from '../components/Dashboard/Referrals';
import Leaderboard from '../components/Dashboard/Leaderboard';
import ToDo from '../components/Dashboard/ToDo';
import ExpiringCampaigns from '../components/Dashboard/ExpiringCampaigns';
import ExpiringEvents from '../components/Dashboard/ExpiringEvents';

import {
  MissionHeader,
  PulseStrip,
  MasterCard,
  CompositionPanel,
  ActivityPanel,
  EconomyPanel,
  NotificationHealthPanel,
  ModerationPanel,
  CarbonImpactPanel,
  SystemHealthPanel,
  UserHealthPanel,
  EngagementDetailPanel,
  PointsEconomyPanel,
  NotificationDetailPanel,
  ContentVelocityPanel,
  IssuesPanel,
  CarbonByCategoryPanel,
  RecentActivityPanel,
  ReferralsPanel,
  PlatformPanel,
  useMissionData,
} from '../components/MissionControl/panels';

const Dashboard = () => {
  const { data, isPending, isError } = useMissionData();
  return (
    <div className="w-full">
      <div className="flex flex-col gap-4">
        <MissionHeader environment={data?.environment} loading={isPending} />

        {isError && (
          <div className="border border-red rounded-lg bg-redBg px-4 py-3 text-sm text-red font-bold">
            Couldn't reach <code>/admin/dashboard/mission-control</code>. Some panels will show blank until the backend is reachable. The legacy snapshot below is unaffected.
          </div>
        )}

        <PulseStrip data={data} />

        <MasterCard defaultOpen={true}>
          <div className="flex flex-col gap-3">
            <div className="w-full grid lg:grid-cols-3 gap-3">
              <ToDo />
              <ExpiringCampaigns />
              <ExpiringEvents />
            </div>
            <div className="w-full grid lg:grid-cols-6 gap-3">
              <div className="col-span-3"><Snapshot /></div>
              <div className="col-span-3"><TrackImpactMatrix /></div>
            </div>
            <div className="w-full grid lg:grid-cols-7 gap-3">
              <div className="col-span-3"><SubmissionStats /></div>
              <div className="col-span-2"><Referrals /></div>
              <div className="col-span-2"><Leaderboard /></div>
            </div>
          </div>
        </MasterCard>

        <CompositionPanel data={data} />
        <UserHealthPanel data={data} />
        <PlatformPanel data={data} />
        <ReferralsPanel data={data} />
        <ActivityPanel data={data} />
        <EngagementDetailPanel data={data} />
        <EconomyPanel data={data} />
        <PointsEconomyPanel data={data} />
        <NotificationHealthPanel data={data} />
        <NotificationDetailPanel data={data} />
        <ModerationPanel data={data} />
        <ContentVelocityPanel data={data} />
        <IssuesPanel data={data} />
        <CarbonImpactPanel data={data} />
        <CarbonByCategoryPanel data={data} />
        <SystemHealthPanel />
        <RecentActivityPanel data={data} />
      </div>
      <ToastContainer position="bottom-right" autoClose={2000} />
    </div>
  );
};

export default Dashboard;
